import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {AsyncMarkerMap} from '../../common/maps/AsyncMarkerMap';
import {highlightInMap, clearMapHighlight, clearCarouselFocus} from '../../../actions/greatPlaces';
import {goToPinnedSerp, showDatesPopup} from '../../../actions/search';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {SegmentFilters} from './SegmentFilters';
import {RetryCard} from './RetryCard';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {LoadingOverlay} from '../../common/overlays/loading/LoadingOverlay';
import {TESTS} from '../../../utils/abacus';
import {UNREFINED_KEY} from '../../../../shared/utils/listings';
import {AllListingsButtonComponent} from '../../common/listings/AllListingsButton';
import {itemType, itemProps} from '../../common/structured-data/structuredData';
import {wrapInTest} from '../../common/mvt/utils/mvt';

import {CardCarousel} from '../../common/carousel/Carousel';
import {GreatPlacesRatioCard} from '../../common/carousel/GreatPlacesCard';
import {SeeMorePropertiesRatioCard} from '../../common/carousel/SeeMorePropertiesCard';

function onMouseOverCard(dispatch, id) {
    return () => {
        dispatch(highlightInMap(id));
        dispatch(clearCarouselFocus());
    };
}

function onMouseOutCard(dispatch) {
    return () => {
        dispatch(clearMapHighlight());
    };
}

export function sendToEdap(tripleId, eventrefinements) {
    const delayProcessing = {delayProcessing: true};
    const mainData = {
        actionlocation: 'properties-module',
        listingid: tripleId,
        eventrefinements
    };

    pushEdapEvent('property.tile.click', mainData, delayProcessing);
}

export function onCardClick({dispatch, listing, types}) {
    return (evt) => {
        sendToEdap(listing.tripleId, types);

        evt.preventDefault();

        const {propertyName, tripleId, listingUri} = listing;

        dispatch(showDatesPopup({
            actionLocation: 'properties-module',
            eventrefinements: types,
            goToSerpAction: goToPinnedSerp,
            propertyName,
            tripleId,
            listingUri,
            thumbnailUrl: listing.thumbnailUrl
        }));
    };
}

function listingAsPropertyRatioCard(
    dispatch,
    types,
    highlightedId,
    isMobile,
    deviceType,
    canonicalHref
) {
    const isTablet = deviceType === 'tablet';
    const horizontalScrollContainer = {
        event: (isMobile || isTablet) ? 'scroll' : 'transitionend',
        element: (isMobile || isTablet) ? '.great-places-to-stay .CardCarousel__container--scrolling' : '.great-places-to-stay .CardCarousel__viewbox'
    };
    return (listing, position) => (
        <GreatPlacesRatioCard
            highlighted={listing.id === highlightedId}
            horizontalScrollContainer={horizontalScrollContainer}
            imageSrc={listing.thumbnailUrl}
            instantBookable={listing.tooltip}
            isMobile={isMobile}
            key={listing.id}
            link={`//${listing.listingUri}`}
            onClick={onCardClick({dispatch, listing, types})}
            onMouseOut={onMouseOutCard(dispatch)}
            onMouseOver={onMouseOverCard(dispatch, listing.id)}
            position={position}
            price={listing.price}
            propertyName={listing.propertyName}
            propertyType={listing.propertyType}
            review={listing.review}
            seoLink={`${canonicalHref}#listing-${listing.tripleId}`}
            toplineDescription={listing.toplineDescription}
        />
    );
}
function validLocation({geoCode}) {
    return geoCode.addressLatLngIsValid;
}

function convertListingToMarker(listing) {
    const id = `${listing.id}-${listing.unitUuid}`;

    const position = {
        lat: listing.geoCode.latitude,
        lng: listing.geoCode.longitude
    };

    const showExactLocation = listing.geoCode.showExactLocation;
    const key = listing.id;

    return {
        id,
        position,
        showExactLocation,
        key,
        label: listing.price.shortLabel
    };
}

export class GreatPlacesToStayComponent extends Component {
    render() {
        const {
            dispatch,
            listings = [],
            highlightedId,
            carouselFocus,
            propertyType,
            isMobile,
            abacus,
            segmentFilters,
            deviceType,
            segmentKey,
            inventoryCount,
            classNameCta,
            canonicalHref,
            pageTitle,
            mapTitle,
            title,
            lastCardUrl,
            hideGoogleMap
        } = this.props;

        if (listings.length === 0) {
            return null;
        }
        const markers = listings
            .filter(validLocation)
            .map(convertListingToMarker);

        const types = getRefinements({propertyType, refinementKey: segmentFilters.key});

        const propertyRatioCards = listings
            .slice(0, 6)
            .map(listingAsPropertyRatioCard(
                dispatch,
                types,
                highlightedId,
                isMobile,
                deviceType,
                canonicalHref
            ));
        propertyRatioCards.push(
            <SeeMorePropertiesRatioCard
                key={-1}
                lastCardUrl={lastCardUrl}
            />
        );
        const listingsIdIndex = listings
            .map((listing) => listing.id)
            .indexOf(carouselFocus);

        const focusedIndex = listingsIdIndex === -1
            ? null
            : listingsIdIndex;

        const prominentCta = (
            <AllListingsButtonComponent
                {...this.props}
                dispatch={dispatch}
                types={types}
                inventoryCount={inventoryCount}
                className={classNameCta}
                label={mapTitle}
                lastCardUrl={lastCardUrl}
            />
        );

        const map = (
            <div className={'great-places-to-stay__map'}>
                {!isMobile && (
                    <Fragment>
                        {prominentCta}
                        <AsyncMarkerMap
                            dispatch={dispatch}
                            types={types}
                            segmentKey={segmentKey}
                            inventoryCount={inventoryCount}
                            loadingElement={<LoadingOverlay />}
                            clickableMarker
                            highlightedId={highlightedId}
                            markers={markers}
                            listings={listings}
                            isLoading={segmentFilters.loading}
                            hasFailed={segmentFilters.failed}
                            apiKey={'AIzaSyAFpxfcM4meoHs0Nt5BX8-bMcY7SEidAPE'}
                            fallback={<RetryCard />}
                        />
                    </Fragment>
                )}
            </div>
        );


        const carouselElement = (<div className={'card-carousel'}>
            <CardCarousel
                titleMessage={''}
                focusIndex={focusedIndex}
                aspectRatio={'4x3'}
                breakpoints={{
                    '1600': 4,
                    '1200': 4,
                    '992': 4,
                    '768': 3,
                    '480': 2,
                    '0': isMobile ? 2 : 4
                }}>
                {propertyRatioCards}
            </CardCarousel>
        </div>);

        const carouselWithRatioCards = wrapInTest(abacus, TESTS.PROPERTY_NAME_IN_LISTING_CARD, carouselElement);

        const carousel = isMobile && segmentFilters.failed ? <RetryCard /> : carouselWithRatioCards;

        return (
            <div className={'container module module--no-padding great-places-to-stay'} {...itemType('ItemList')}>
                <div {...itemType('CollectionPage', 'mainEntityOfPage')}>
                    {itemProps({url: canonicalHref, name: pageTitle})}
                </div>
                <div className={'great-places-to-stay-hd'}>
                    <h2 className={'great-places-to-stay__title'}>{title}</h2>
                    <SegmentFilters />
                    {!hideGoogleMap && map}
                </div>
                {carousel}
                {isMobile && (prominentCta)}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    const {
        segmentFilters: {key = UNREFINED_KEY},
        segments
    } = state.destination;
    const isSegment = key !== UNREFINED_KEY && segments.length;
    const inventoryCount = isSegment ? segments.find((segment) => segment.messageKey === key).count : state.destination.inventoryCount;
    return {
        listings: state.destination.listings,
        carouselFocus: state.greatPlaces.carouselFocus,
        highlightedId: state.greatPlaces.highlightedId,
        inventoryCount,
        segmentKey: key,
        propertyType: state.destination.propertyType,
        isMobile: state.config.isMobile,
        deviceType: state.config.deviceType,
        abacus: state.abacus,
        segmentFilters: state.destination.segmentFilters,
        serpUrlFilters: state.destination.serpUrlFilters,
        canonicalHref: state.destination.canonicalHref,
        pageTitle: state.destination.pageTitle,
        mapTitle: state.modules.searchMessages.mapTitle,
        title: state.greatPlaces.title,
        lastCardUrl: state.destination.lastCardUrl,
        hideGoogleMap: state.greatPlaces.hideGoogleMap
    };
}

export const GreatPlacesToStay = connect(mapStateToProps)(determineIfMobile(GreatPlacesToStayComponent));
